import * as types from '../const/action.types';

export function setTabAlert(value) {
    return {
        type: types.SET_ALERT_TAB,
        value,
    };
}



// WEBPACK FOOTER //
// ./src/actions/alert.tabs.actions.js